import { render, staticRenderFns } from "./GrcTextArea.vue?vue&type=template&id=4a7312c9&scoped=true&"
import script from "./GrcTextArea.vue?vue&type=script&lang=js&"
export * from "./GrcTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7312c9",
  null
  
)

export default component.exports